import styled from "styled-components";

const PropertyItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  font-size: inherit;
  line-height: 1.5;
  font-weight: ${props => props.highlighted && "bold"};

  color: ${props => (props.highlighted ? "#93BD6B" : "inherit")};
  > * {
    margin-right: 0.3rem;
  }
`;

export default PropertyItem;
